import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { useLang } from "@/common/Contexts/LanguageContext";
import { CDN_LINK } from "@globalConfig";
import { trackEvents } from "@/common/events/events";
import ProfileLayOut from "@/pages/user/ProfileComponents/ProfileLayOut/ProfileLayout";
import stl from "./UserAccountComponent.module.css";
import useHelpers from "@hooks/useHelpers";
import { useAuthActions, useSession } from "@/_MiniApps/auth/AuthContext";
import { getPlatformInfo } from "@/utils/GlobalJavascriptFunction";
var UserAccountComponent = function UserAccountComponent() {
  var lang = useLang();
  var _useSession = useSession(),
    user = _useSession.user;
  var _useAuthActions = useAuthActions(),
    logout = _useAuthActions.logout;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var _useTranslation = useTranslation(["web_user_account", "web_tracking", "web_favorite"]),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ProfileLayOut, {
    title: t("account", {
      ns: "web_user_account"
    }),
    wideContainer: true,
    className: "m-hide"
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.mainContainer
  }, /*#__PURE__*/React.createElement("a", {
    href: createUrl("/user/account/my-info")
  }, /*#__PURE__*/React.createElement("section", {
    className: stl.subContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.flex
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/person_black_24dp@1.svg"
  }), /*#__PURE__*/React.createElement("span", null, t("my_information", {
    ns: "web_user_account"
  }))), /*#__PURE__*/React.createElement("img", {
    className: stl.arrow,
    src: CDN_LINK + "/assets/images/arrow-down-1@1.svg"
  }))), /*#__PURE__*/React.createElement("a", {
    href: createUrl("/tracking-landing"),
    onClick: function onClick() {
      return trackEvents("order_tracking_entry", {
        referral_location: "account_page",
        platform: getPlatformInfo()
      });
    }
  }, /*#__PURE__*/React.createElement("section", {
    className: stl.subContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.flex
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/orders@1.svg"
  }), /*#__PURE__*/React.createElement("span", null, t("track_orders", {
    ns: "web_tracking"
  }))), /*#__PURE__*/React.createElement("img", {
    className: stl.arrow,
    src: CDN_LINK + "/assets/images/arrow-down-1@1.svg"
  }))), /*#__PURE__*/React.createElement("a", {
    href: createUrl("/user/favorite")
  }, /*#__PURE__*/React.createElement("section", {
    className: stl.subContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.flex
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/favorite_border_black_24dp@1.svg",
    alt: "favorite"
  }), /*#__PURE__*/React.createElement("span", null, t("favorite_cars", {
    ns: "web_tracking"
  }))), /*#__PURE__*/React.createElement("img", {
    className: stl.arrow,
    src: CDN_LINK + "/assets/images/arrow-down-1@1.svg",
    alt: "arrow"
  }))), /*#__PURE__*/React.createElement("a", {
    href: createUrl("/site/saved-search")
  }, /*#__PURE__*/React.createElement("section", {
    className: stl.subContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.flex
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/saved-search-icon-outlined.svg",
    alt: "favorite"
  }), /*#__PURE__*/React.createElement("span", null, t("saved_searches_2", {
    ns: "saved_search"
  }))), /*#__PURE__*/React.createElement("img", {
    className: stl.arrow,
    src: CDN_LINK + "/assets/images/arrow-down-1@1.svg",
    alt: "arrow"
  }))), /*#__PURE__*/React.createElement("a", {
    href: createUrl("/site/recently-viewed")
  }, /*#__PURE__*/React.createElement("section", {
    className: stl.subContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.flex
  }, /*#__PURE__*/React.createElement("img", {
    width: "24px",
    src: CDN_LINK + "/assets/images/recentViesIconBlue.svg",
    alt: "recent views"
  }), /*#__PURE__*/React.createElement("span", null, t("recently_viewed_cars", {
    ns: "web_favorite"
  }))), /*#__PURE__*/React.createElement("img", {
    className: stl.arrow,
    src: CDN_LINK + "/assets/images/arrow-down-1@1.svg",
    alt: "arrow"
  }))), /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: (/*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              e.preventDefault();
              trackEvents("user_logout", {
                ui_language: lang
              });
              _context.n = 1;
              return logout();
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }())
  }, /*#__PURE__*/React.createElement("section", {
    className: [stl.logOut, stl.subContainer].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.flex
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/round-exit_to_app-24px_1@1.svg",
    alt: "logout"
  }), /*#__PURE__*/React.createElement("span", null, t("logout", {
    ns: "web_user_account"
  })))))));
};
export default UserAccountComponent;